import {
  ContributionClassesAndRolesDDL,
  ContributionClassName,
  ContributionIdTypes,
} from 'types/contribution';
import {
  DetailField,
  RoleFieldsInfo,
} from 'app/components/Song/Contributions/ContributionForm/RoleFields/types';
import { PerformerRoleType } from 'app/components/Song/Contributions/ContributionForm/types';
import {
  getOptions,
  getGroupedOptions,
} from 'app/components/Song/Contributions/ContributionForm/RoleFields/utils';

export const idFieldInfoMap = {
  [ContributionClassName.ARTIST]: {
    subtitle: 'IPN',
    type: ContributionIdTypes.IPN,
    idFieldLabel: 'Artist ID (IPN)',
    idFieldName: 'artistIpn',
    tooltip: 'International Performer Number (IPN)',
  },
  [ContributionClassName.SONGWRITER]: {
    subtitle: 'IPI',
    type: ContributionIdTypes.IPI,
    idFieldLabel: 'Songwriter ID (IPI)',
    idFieldName: 'composerIpi',
    tooltip: 'Interested Parties Information (IPI)',
  },
  [ContributionClassName.PRODUCTION]: {
    subtitle: 'IPN',
    type: ContributionIdTypes.IPN,
    idFieldLabel: 'Contributor ID (IPN)',
    idFieldName: 'producerIpn',
    tooltip: 'International Performer Number (IPN)',
  },
  [ContributionClassName.PERFORMER]: {
    subtitle: 'IPN',
    type: ContributionIdTypes.IPN,
    idFieldLabel: 'Performer ID (IPN)',
    idFieldName: 'performerIpn',
    tooltip: 'International Performer Number (IPN)',
  },
};

export const isniFieldInfoMap = {
  [ContributionClassName.ARTIST]: 'artistIsni',
  [ContributionClassName.SONGWRITER]: 'composerIsni',
  [ContributionClassName.PRODUCTION]: 'producerIsni',
  [ContributionClassName.PERFORMER]: 'performerIsni',
};

export const roleFieldsInfoMap: (
  contributionClassesAndRolesDDL: ContributionClassesAndRolesDDL
) => Record<ContributionClassName, RoleFieldsInfo> = (
  contributionClassesAndRolesDDL
) => ({
  [ContributionClassName.ARTIST]: {
    subtitle: 'Role',
    fieldLabel: 'Role',
    fieldName: 'artistRole',
    roleOptions: getOptions(contributionClassesAndRolesDDL.artistRoles),
    tooltip:
      'Artist Role distinguishes the primary performing artists, you can indicate additional artist collaborations such as "feat." and "with"',
  },
  [ContributionClassName.SONGWRITER]: {
    subtitle: 'Role',
    fieldLabel: 'Role',
    fieldName: 'composerRole',
    roleOptions: getOptions(contributionClassesAndRolesDDL.compositionRoles),
    tooltip:
      'Songwriter role defines the type of contribution made, such as Composer/Author (CA), Author (A) or a Translator (TR)',
  },
  [ContributionClassName.PRODUCTION]: {
    subtitle: 'Role',
    fieldLabel: 'Role',
    fieldName: 'productionRole',
    roleOptions: getOptions(contributionClassesAndRolesDDL.productionRoles),
    tooltip:
      'Production Role defines the specific contribution type made to the sound recording, such as Mix, Mastering Engineer, Co-Producer, Assistant, Vocal Coach',
  },
  [ContributionClassName.PERFORMER]: {
    subtitle: 'Role',
    fieldLabel: 'Role',
    fieldName: 'performerRole',
    roleOptions: getOptions(contributionClassesAndRolesDDL.performanceRoles),

    detailField: (type?: string): DetailField => {
      const options = getGroupedOptions(
        type || '',
        contributionClassesAndRolesDDL
      );

      switch (type) {
        case PerformerRoleType.VOCAL:
        case PerformerRoleType.VOCALIST: {
          return {
            label: 'Select Detail',
            options,
          };
        }
        case PerformerRoleType.MUSICIAN: {
          return {
            label: 'Select Instrument',
            options,
          };
        }
        case PerformerRoleType.GROUP:
        case PerformerRoleType.ENSEMBLE: {
          return {
            label: 'Select Detail',
            options,
          };
        }
        default: {
          return {
            label: 'Select Detail',
          };
        }
      }
    },
    tooltip:
      'Performer Role defines the type (Vocal, Musician, Group) and the specifics (Vocal, Backing Vocal, Electric Guitar, Keyboards, Choir, Spoken Word)',
  },
});
